import { CreditUsageButtonProps } from 'blaze-ui/CreditUsageButton/Types'
import { forwardRef } from 'react'
import { Button } from 'blaze-ui/Button'
import { Credits } from 'blaze-ui/icons/20/Credits'
import Styles from './CreditUsageButton.module.scss'

export const CreditUsageButton = forwardRef<HTMLButtonElement, CreditUsageButtonProps>(({
  credits,
  children,
  ...props
}, fRef) => {
  return (
    <Button
      ref={fRef}
      {...props}
      endIcon={() => <><Credits size={16}/><span className={Styles.credits}>{credits}</span></>}
    >
      {children}
    </Button>
  )
})
